import { useEffect, useState } from "react";

const DURATION_MS = (23 * 3600 + 46 * 60 + 13) * 1000;
const STORAGE_KEY = "launch-deadline";

function getDeadline(): number {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) return Number(stored);
    const deadline = Date.now() + DURATION_MS;
    sessionStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  } catch {
    return Date.now() + DURATION_MS;
  }
}

export function useCountdown() {
  const [deadline] = useState(getDeadline);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const remaining = Math.max(0, deadline - now);
  const totalSeconds = Math.floor(remaining / 1000);
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}
